import { render } from "./chooseTransportToCopyModal.vue?vue&type=template&id=24ca71be&scoped=true&ts=true"
import script from "./chooseTransportToCopyModal.vue?vue&type=script&lang=ts"
export * from "./chooseTransportToCopyModal.vue?vue&type=script&lang=ts"

import "./chooseTransportToCopyModal.vue?vue&type=style&index=0&id=24ca71be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ca71be"]])

export default __exports__